module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right_col",
    attrs: {
      "role": "main"
    }
  }, [_c('MessageView'), _c('loading'), _c('div', {
    staticClass: "header"
  }, [_vm._m(0), _c('div', {
    staticClass: "customerchat"
  }, [_c('div', {
    attrs: {
      "id": "chat-frame"
    }
  }, [_c('div', {
    staticClass: "chat-inframe"
  }, [_vm._l((_vm.messages), function(message, index) {
    return _c('div', {
      staticClass: "chat-area"
    }, [_c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (message.user_id),
        expression: "message.user_id"
      }],
      staticClass: "chat-talk"
    }, [_vm._m(1, true), _c('small', [_vm._v(_vm._s(message.created_at))]), _c('pre', [_c('span', {
      staticClass: "talk-content"
    }, [_vm._v(_vm._s(message.text))])]), _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (message.file_name),
        expression: "message.file_name"
      }],
      staticClass: "myattachments btn-link",
      on: {
        "click": function($event) {
          _vm.download(message.no, message.file_name)
        }
      }
    }, [_vm._v(_vm._s(message.file_name))])]), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!message.user_id),
        expression: "!message.user_id"
      }],
      staticClass: "chat-talk client"
    }, [_c('span', {
      staticClass: "talk-icon"
    }, [_c('img', {
      attrs: {
        "src": message.clientSrc
      }
    })]), _c('small', [_vm._v(_vm._s(message.created_at))]), _c('pre', [_c('span', {
      staticClass: "talk-content"
    }, [_vm._v(_vm._s(message.text))])]), _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (message.file_name),
        expression: "message.file_name"
      }],
      staticClass: "yourattachments btn-link",
      on: {
        "click": function($event) {
          _vm.download(message.no, message.file_name)
        }
      }
    }, [_vm._v(_vm._s(message.file_name))])])])
  }), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.text),
      expression: "text"
    }],
    staticClass: "chatbox",
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "placeholder": "返信内容を入力してください",
      "rows": "5"
    },
    domProps: {
      "value": (_vm.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.text = $event.target.value
      }
    }
  }), _c('div', {
    staticClass: "attachmentfile",
    staticStyle: {
      "float": "left"
    }
  }, [_c('button', {
    staticStyle: {
      "float": "left"
    },
    on: {
      "click": _vm.fileSelect
    }
  }, [_vm._v("ファイル選択")]), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "id": "file"
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.file),
      expression: "file"
    }],
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.file))]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.file),
      expression: "!file"
    }],
    staticClass: "small",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("1ファイルのみ添付可能です"), _c('br'), _vm._v("添付できるファイルは最大1MBまでとなります")])]), _c('div', {
    staticClass: "action",
    staticStyle: {
      "float": "right"
    }
  }, [_c('div', {
    staticClass: "send_button"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.text),
      expression: "text"
    }],
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.send
    }
  }, [_vm._v("送  信")])])])], 2)])])]), _c('footer-row')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar navbar-inverse navbar-embossed navbar-custom",
    attrs: {
      "role": "navigation"
    }
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("Racooo")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "talk-icon company"
  }, [_c('i', {
    staticClass: "fa fa-building-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4103b8ff","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/communication/Index.vue
// module id = 597
// module chunks = 1